/**
 * Prevent search engines from indexing a page.
 * Adds a noindex, nofollow meta tag on mount and removes it on unmount.
 */
export default {
    mounted() {
        const robots_meta = document.createElement('meta');
        robots_meta.name = 'robots';
        robots_meta.content = 'noindex, nofollow';
        document.head.appendChild(robots_meta);
    },

    beforeDestroy() {
        const robots_meta = document.querySelector('meta[name="robots"]');
        if (robots_meta) {
            robots_meta.remove();
        }
    }
};
